var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagnosisLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5571_29437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V9.5C4 10.9587 4.57946 12.3576 5.61091 13.3891C6.64236 14.4205 8.04131 15 9.5 15C10.9587 15 12.3576 14.4205 13.3891 13.3891C14.4205 12.3576 15 10.9587 15 9.5V6C15 5.46957 14.7893 4.96086 14.4142 4.58579C14.0391 4.21071 13.5304 4 13 4H12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 15.7879 9.15519 16.5681 9.45672 17.2961C9.75825 18.0241 10.2002 18.6855 10.7574 19.2426C11.3145 19.7998 11.9759 20.2417 12.7039 20.5433C13.4319 20.8448 14.2121 21 15 21C15.7879 21 16.5681 20.8448 17.2961 20.5433C18.0241 20.2417 18.6855 19.7998 19.2426 19.2426C19.7998 18.6855 20.2417 18.0241 20.5433 17.2961C20.8448 16.5681 21 15.7879 21 15V12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3V5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3V5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10C19 10.5304 19.2107 11.0391 19.5858 11.4142C19.9609 11.7893 20.4696 12 21 12C21.5304 12 22.0391 11.7893 22.4142 11.4142C22.7893 11.0391 23 10.5304 23 10C23 9.46957 22.7893 8.96086 22.4142 8.58579C22.0391 8.21071 21.5304 8 21 8C20.4696 8 19.9609 8.21071 19.5858 8.58579C19.2107 8.96086 19 9.46957 19 10Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5571_29437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosisLarge);
export default __webpack_public_path__ + "static/media/diagnosisLarge.ac696f04d639c252fef99dfa9ce50599.svg";
export { ForwardRef as ReactComponent };